import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph, spaceMixin, Tag, token } from '@zillow/constellation';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import useQueryVariables from '../../../../../../../../hooks/useQueryVariables';
import { getIsAcceptedOrInvitedToMoveIn, INVITE_TO_MOVE_IN_QUERY } from '../../../../../../../../utils/inviteToMoveIn';
import {
  applicationOverallStatusTypes,
  applicationStatusTypes,
} from '../../../../../../../../constants/statusConstants';
import { getApplicantText } from '../../../../../../../../utils/listingApplicationListUtil';

export const StatusHeader = styled(Paragraph)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-transform: uppercase;
  font-weight: ${token('fontWeights.finePrintHeading')};

  &.accepted,
  &.invited_to_move_in {
    color: ${token('colors.green300')};
  }
`;

const StatusHeaderWrapper = styled.div`
  min-height: ${spaceMixin('sm')};
`;

export default function ListingApplicationCardStatusHeader({ applicants, applicationId }) {
  const { propertyId } = useQueryVariables();
  const { data, loading, error } = useQuery(INVITE_TO_MOVE_IN_QUERY, { variables: { propertyId, applicationId } });
  const overallStatus = data?.property?.application?.status;
  const isAcceptedOrInvitedToMoveIn = getIsAcceptedOrInvitedToMoveIn(data);
  const isConditionallyApproved = overallStatus === applicationOverallStatusTypes.CONDITIONALLY_APPROVED;
  const applicantText = getApplicantText({
    applicants,
  });

  return (
    <StatusHeaderWrapper>
      {!loading && !error && (
        <>
          {isAcceptedOrInvitedToMoveIn && (
            <Tag appearance="success" marginBottom="xs">
              {applicationStatusTypes.INVITED_TO_MOVE_IN.label}
            </Tag>
          )}
          {isConditionallyApproved && (
            <Tag appearance="warning" marginBottom="xs">
              {applicationStatusTypes.CONDITIONALLY_APPROVED.label}
            </Tag>
          )}
          <StatusHeader
            fontColor="textMedium"
            fontType="finePrintHeading"
            className="ListingApplicationCard__Text"
            type="body-tiny"
          >
            {applicantText}
          </StatusHeader>
        </>
      )}
    </StatusHeaderWrapper>
  );
}

ListingApplicationCardStatusHeader.propTypes = {
  applicants: PropTypes.array.isRequired,
  applicationId: PropTypes.string.isRequired,
};
